(function () {
  if (!window.fetch) return;

  const originalFetch = window.fetch;

  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(function (response) {
      try {
        const url = arguments[0];

        if (
          typeof url === "string" &&
          (url.includes("/cart/add") || url.includes("/cart/add.js"))
        ) {
          if (window.fbq) {
            fbq("track", "AddToCart");
          }
        }
      } catch (e) {}
      return response;
    });
  };
})();
